import React, { useState } from 'react'
import {
  BrowserRouter as Router,
  Link,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'
import {
  Layout,
  Menu,
  Breadcrumb,
  Icon,
  Avatar,
  Button,
  Dropdown,
  Input,
} from 'antd'
import './AxiomLayout.css'

import DashboardView from './../dashboard/DashboardView'
import RecruitmentsView from './../recruitments/RecruitmentsView'
import RecruitmentsAddView from './../recruitments/RecruitmentsAddView'
import RecruitmentsDetailView from './../recruitments/RecruitmentsDetailView'
import UsersView from '../users/UsersView'
import UserDetailForm from '../users/UserDetailForm'
import UserEditForm from '../users/UserEditForm'
import PhotosView from '../photos/PhotosView'
import PhotosImport from '../photos/PhotosImport'
import VideosView from '../videos/VideosView'
import DocumentsView from '../documents/DocumentsView'
import MapsView from '../maps/MapsView'
import AccessView from '../monitor/AccessView'
import ActivityView from '../monitor/ActivityView'
import JoinUs from './../join-us/JoinUsView'
import JoinUsForgotPassword from '../join-us/JoinUsForgotPassword'
import JoinUsResetPassword from '../join-us/JoinUsResetPassword'
import ThankYouView from './../thank-you/ThankYouView'
import authService from '../services/authentication.service'

import searchHandler from '../commons/SearchHandler'
import SharedPhotosView from '../photos/SharedPhotosView'
import SharedDocumentView from '../documents/SharedDocumentView'

const { Header, Content, Footer, Sider } = Layout
const { SubMenu } = Menu
const { Search } = Input

const AxiomLayout = () => {
  const [toLogin, setToLogin] = useState(false)
  const [collapsed, setCollapsed] = useState(false)

  const [showSearch, setShowSearch] = useState(false)

  searchHandler.setShowSearchStateFn(setShowSearch)

  const user = authService.getAuthenticatedUser()

  const handleLogout = async (event) => {
    console.log('handleLogout...')
    await authService.logOut()
    setToLogin(true)
  }

  const menu = (
    <Menu>
{/*      <Menu.Item>
        <Button type="link">Profile</Button>
      </Menu.Item>
      <Menu.Divider />*/}
      <Menu.Item>
        <Button type="link" onClick={handleLogout}>
          Log out
        </Button>
      </Menu.Item>
    </Menu>
  )

  const currentPath = window.location.pathname

  if (toLogin === true) {
    return <Redirect to="/login" />
  } else if (
    currentPath.includes('joinus') ||
    currentPath.includes('thankyou')
  ) {
    return (
      <Router>
        <Switch>
          <Route exact path="/joinus" component={JoinUs} />
          <Route
            exact
            path="/joinus/forgot_password"
            component={JoinUsForgotPassword}
          />
          <Route
            exact
            path="/joinus/reset_password"
            component={JoinUsResetPassword}
          />
          <Route exact path="/thankyou" component={ThankYouView} />
        </Switch>
      </Router>
    )
  } else {

    const key = currentPath.includes('recruitments')
      ? 'recruitments'
      : currentPath.includes('dashboard')
      ? 'dashboard'
      : currentPath.includes('documents')
      ? 'documents'
      : currentPath.includes('maps')
      ? 'maps'
      : currentPath.includes('videos')
      ? 'videos'
      : currentPath.includes('/photos/explorer')
      ? 'photos_explorer'
      : currentPath.includes('/photos/import')
      ? 'photos_import'
      : currentPath.includes('users')
      ? 'users'
      : currentPath.includes('/monitor/access')
      ? 'monitor_access'
      : currentPath.includes('/monitor/activity')
      ? 'monitor_activity'
      : null
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Layout>
          <Sider
            collapsible
            collapsedWidth={60}
            style={{ background: '#37444C', boxShadow: '1px 0 20px 0 #3f4d67'}}
            onCollapse={(collapsed) => {
              setCollapsed(collapsed)
            }}
          >
            {!collapsed && (
                <Menu
                    theme="dark"
                    defaultSelectedKeys={[key]}
                    mode="inline"
                    style={{
                        marginTop: '10px',
                        background: '#37444C',
                        height: '100px',
                    }}
                    inlineCollapsed={true}
                >
                  <div className="logo">
                    <Dropdown
                        overlay={menu}
                        placement="topRight"
                        trigger={['click']}
                    >
                      <Button
                          style={{background: '#37444C', borderColor: '#37444C'}}
                          size="large"
                      >
                        <Avatar size="large" icon="user"/>

                      </Button>
                    </Dropdown>
                  </div>
                  <div
                      style={{
                          color: '#fff',
                          margin: '5px 10px 25px 10px',
                          fontSize: '15px',
                          textAlign: 'center'
                      }}
                  >
                      {(user.firstName + ' '+ user.lastName).substr(0,25)}
                  </div>
                </Menu>
            )}
            {collapsed && (
              <Menu
                theme="dark"
                defaultSelectedKeys={[key]}
                mode="inline"
                style={{
                  marginTop: '10px',
                  background: '#37444C',
                  height: '100px',
                  borderRight: '0px',
                }}
                inlineCollapsed={true}
              >
                <div className="logo_collapsed">
                  <Dropdown
                    overlay={menu}
                    placement="topRight"
                    trigger={['click']}
                  >
                    <Button
                      style={{
                        background: '#37444C',
                        borderColor: '#37444C',
                        padding: '0px 8px',
                      }}
                      size="large"
                    >
                      <Avatar size="large" icon="user" />
                    </Button>
                  </Dropdown>
                </div>
              </Menu>
            )}
            <Menu
              id="menu-sider"
              theme="dark"
              defaultSelectedKeys={[key]}
              mode="inline"
              style={{
                marginTop: '10px',
                background: '#37444C',
                borderRight: '0px',
              }}
              inlineCollapsed={true}
              /*defaultOpenKeys={['monitor']}*/
            >
              {/*<Menu.Item key="dashboard">*/}
                {/*<Link to="/dashboard">*/}
                  {/*<Icon type="home" />*/}
                  {/*<span>Dashboard</span>*/}
                {/*</Link>*/}
              {/*</Menu.Item>*/}

              {'Administrator' === user.role && (
                <Menu.Item key="recruitments">
                  <Link to="/recruitments">
                    <Icon type="file-done" />
                    <span>Recruitments</span>
                  </Link>
                </Menu.Item>
              )}
              <Menu.Item key="documents">
                <Link to="/documents">
                  <Icon type="book" />
                  <span>Documents</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="maps">
                <Link to="/maps">
                  <Icon type="compass" />
                  <span>Maps</span>
                </Link>
              </Menu.Item>
              <SubMenu
                  key="photos"
                  title={
                    <span>
                      {' '}
                      <Icon type="camera" /> <span>Photos</span>{' '}
                    </span>
                  }
              >
                <Menu.Item key="photos-explorer">
                  <Link to="/photos/explorer">
                    <span>Explorer</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="photos-import">
                  <Link to="/photos/import">
                    <span>Import</span>
                  </Link>
                </Menu.Item>
              </SubMenu>
              {/*<Menu.Item key="photos">
                <Link to="/photos">
                  <Icon type="camera" />
                  <span>Photos</span>
                </Link>
              </Menu.Item>*/}
              <Menu.Item key="videos">
                <Link to="/videos">
                  <Icon type="video-camera" />
                  <span>Videos</span>
                </Link>
              </Menu.Item>
              {'Administrator' === user.role && (
                <Menu.Item key="users">
                  <Link to="/users">
                    <Icon type="team" />
                    <span>Users</span>
                  </Link>
                </Menu.Item>
              )}
              {'Administrator' === user.role && (
                <SubMenu
                  key="monitor"
                  title={
                    <span>
                      {' '}
                      <Icon type="monitor" /> <span>Monitor</span>{' '}
                    </span>
                  }
                >
                  <Menu.Item key="monitor-access">
                    <Link to="/monitor/access">
                      <span>Access</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="monitor-activity">
                    <Link to="/monitor/activity">
                      <span>Activity</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>
              )}
            </Menu>
          </Sider>
          <Layout style={{ background: '#EEEEEE' }}>
            <Content
              style={{
                margin: '0 40px',
                display: 'flex',
                flexDirection: 'column',
                background: '#EEEEEE',
              }}
            >
              {/*<Route exact path="/dashboard" component={DashboardView} />*/}
              <Route exact path="/recruitments" component={RecruitmentsView} />
              <Route exact path="/users" component={UsersView} />
              <Route exact path="/users/detail" component={UserDetailForm} />
              <Route exact path="/users/edit" component={UserEditForm} />
              <Route
                exact
                path="/recruitments/add"
                component={RecruitmentsAddView}
              />
              <Route
                exact
                path="/recruitments/edit"
                component={RecruitmentsDetailView}
              />
              <Route path="/photos/explorer" component={PhotosView} />
              <Route path="/photos/import" component={PhotosImport} />
              {/*<Route path="/photos" component={PhotosView} />*/}
              <Route path="/videos" component={VideosView} />
              <Route path="/documents" component={DocumentsView} />
              <Route path="/maps" component={MapsView} />
              <Route exact path="/monitor/access" component={AccessView} />
              <Route exact path="/monitor/activity" component={ActivityView} />
            </Content>
            <Footer style={{ textAlign: 'center', height: '10px' }}></Footer>
          </Layout>
        </Layout>
      </Layout>
    )
  }
}

export default AxiomLayout
